import {Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core";
import linkuriCampanie from "../services/linkuriCampanie";

const useStyles = makeStyles(theme=>({
    element: {
        display: 'inline-block',
        verticalAlign: 'middle',
        color: '#fff',
        textDecoration: 'none',
        margin: '0 1% 2%',
        fontSize: '150%',
        [theme.breakpoints.only("xs")]: {
            padding:'0 .5rem',
            fontSize: '100%',
        }


    },
    element_bull: {
        display: 'inline-block',
        verticalAlign: 'middle',
        color: '#fff',
        textDecoration: 'none',
        margin: '0 1% 2%',
        fontSize: '150%',
        [theme.breakpoints.only("xs")]: {
            display:'none'
        }

    }
}))

function MeniuFooter() {

    let list = [
        {
            name: 'Termeni și condiții',
            url: linkuriCampanie.termeni_si_conditii
        },
        null,
        {
            name: 'Politica cookies',
            url: linkuriCampanie.politica_cookies
        },
        null,
        {
            name: 'Politica de confidențialitate',
            url: linkuriCampanie.politica_de_confidentialitate
        },




    ]

    const classes = useStyles();

    return <Grid container spacing={0}>


            <Grid container spacing={0}>
                <Grid item xs={12}>
                    {list.map((item, idx, s) => {
                        if (!item) {
                            return <div key={idx} className={classes.element_bull} style={({fontSize: '300%'})}>&bull;</div>
                        }
                        return <a key={idx}
                                  className={classes.element}
                                  href={item.url}
                                  target={"_blank"}
                                  rel={"noreferrer"}>{item.name}</a>
                    })}
                </Grid>
            </Grid>


    </Grid>
}

export default MeniuFooter;
